import { Box, Dialog } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const authModalStyles = makeStyles(() => ({
  dialog: {
    width: 360,
    maxWidth: '100%',
    '&.wide': {
      width: 460
    }
  },
  container: {
    padding: 20
  },
  header: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#000000'
  },
  message: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,
    marginBottom: '12px'
  },
  buttonContainer: {
    marginTop: '16px'
  },
  submitButton: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#FFFFFF',
    backgroundColor: '#055577',
    '&:hover': {
      backgroundColor: '#042E43',
      boxShadow: 'none'
    }
  },
  cancelButton: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#000000',
    backgroundColor: '#F5F5F5',
    '&:hover': {
      backgroundColor: '#E0E0E0',
      boxShadow: 'none'
    }
  }
}));

type AuthModalProps = {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  type?: 'default' | 'message';
};

const AuthModal = ({
  children,
  isOpen,
  onClose,
  type = 'default'
}: AuthModalProps) => {
  const classes = authModalStyles();

  return (
    <Dialog
      classes={{
        paper: `${classes.dialog} ${type == 'message' ? 'wide' : ''}`
      }}
      open={isOpen}
      onClose={onClose}
      onKeyDown={event => {
        event.stopPropagation();
      }}
    >
      <Box className={classes.container}>{children}</Box>
    </Dialog>
  );
};

export default AuthModal;
